/**
 * P3-32: Religion tab（Ziggurat + Order of the Sun + Cryptotheology + Pacts）。
 */
import { useGameTick } from "../../bridge/useGameTick";
import type { GamePage } from "../../bridge/GameBridge";
import { TooltipProvider } from "../../components/Tooltip/TooltipProvider";
import { ZigguratPanel } from "./ZigguratPanel";
import { OrderOfTheSunPanel } from "./OrderOfTheSunPanel";
import { CryptotheologyPanel } from "./CryptotheologyPanel";
import { PactsPanel } from "./PactsPanel";

export default function ReligionTab() {
  const showSun = useGameTick((game: GamePage | null): boolean => {
    if (!game) {return false;}
    const challenges = game.challenges as { isActive?: (name: string) => boolean } | null;
    return !(challenges?.isActive?.("atheism") ?? false);
  });

  return (
    <TooltipProvider>
      <div className="tabInner Religion">
        <ZigguratPanel />
        {showSun && <OrderOfTheSunPanel />}
        <CryptotheologyPanel />
        <PactsPanel />
      </div>
    </TooltipProvider>
  );
}
